import { CreateOrEditPriceListFormValues } from "../../priceListTypes"
import { SyntheticEvent, useEffect } from "react"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { useFormikContext } from "formik"
import { enqueueSnackbar } from "notistack"
import { Box, Tab, Tabs } from "@mui/material"
import { fieldTabMap, TabsOrder } from "./formConstants"
import { TranslationKey } from "../../../../../localization/translations"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()(() => ({
    tabs: {
        borderBottom: 1,
        borderColor: "divider",
    },
    tab: {
        textTransform: "none",
    },
    error: {
        // color: theme.palette.tailwind.red[500], // make tab red
    },
}))

export function FormTabs(props: { value: number; onChange: (event: SyntheticEvent, newValue: number) => void }) {
    const { value, onChange } = props
    const { l10n } = useAppLocalization()
    const { errors, isSubmitting } = useFormikContext<CreateOrEditPriceListFormValues>()

    const { classes, cx } = useStyles()

    const hasErrors = (tabIndex: number): boolean => {
        return Object.keys(errors).some(
            (field) => fieldTabMap[field as keyof CreateOrEditPriceListFormValues] === tabIndex,
        )
    }

    useEffect(() => {
        let errorMessageKey = undefined

        if (hasErrors(TabsOrder.GENERAL)) {
            errorMessageKey = "create-or-edit-price-list-general-tab-error"
        }
        if (hasErrors(TabsOrder.CUSTOMER)) {
            errorMessageKey = "create-or-edit-price-list-customer-tab-error"
        }
        // if (hasErrors(TabsOrder.PRODUCTS)) {
        //     errorMessageKey = "create-or-edit-price-list-products-tab-error"
        // }
        if (hasErrors(TabsOrder.POS)) {
            errorMessageKey = "create-or-edit-price-list-pos-tab-error"
        }

        if (!errorMessageKey || !isSubmitting) return

        enqueueSnackbar({
            variant: "error",
            message: l10n.getString(errorMessageKey as TranslationKey),
        })
    }, [errors, isSubmitting])

    return (
        <Box className={classes.tabs}>
            <Tabs value={value} onChange={onChange}>
                <Tab
                    value={TabsOrder.GENERAL}
                    label={l10n.getString("create-price-list-tab-general")}
                    className={cx(classes.tab, hasErrors(TabsOrder.GENERAL) && classes.error)}
                    wrapped
                />
                <Tab
                    value={TabsOrder.CUSTOMER}
                    label={l10n.getString("create-price-list-tab-customers")}
                    className={cx(classes.tab, hasErrors(TabsOrder.CUSTOMER) && classes.error)}
                    wrapped
                />
                {/* <Tab
                    value={TabsOrder.PRODUCTS}
                    label={l10n.getString("create-price-list-tab-products")}
                    className={cx(classes.tab, hasErrors(TabsOrder.PRODUCTS) && classes.error)}
                    wrapped
                /> */}
                <Tab
                    value={TabsOrder.POS}
                    label={l10n.getString("create-price-list-tab-pos")}
                    className={cx(classes.tab, hasErrors(TabsOrder.POS) && classes.error)}
                    wrapped
                />
            </Tabs>
        </Box>
    )
}
